import Vue from 'vue'
import Vuex from 'vuex'

import { getUserInfo } from './utils/cache'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    defaultActive: '', // 默认激活菜单
    isHiddenContainer: false,
    memberInfo: {}, // 是否为会员
    isFinishApply: false, // 是否填写过申请表
    username: getUserInfo().username
  },
  mutations: {
    changeActive (state, active) {
      state.defaultActive = active
    },
    changeIsHiddenContainer (state, status) {
      state.isHiddenContainer = status
    },
    changeMemberInfo (state, memberInfo) {
      state.memberInfo = memberInfo
    },
    changeIsFinishApply (state, status) {
      state.isFinishApply = status
    },
    changeUserName (state, Name) {
      state.username = Name
    }
  }
})
